// const MonthSelect = ({
//   selectedMonth,
//   selectedMonthName,
//   months,
//   onChange,
// }) => (
//   <div className="col-sm-3">
//     <select
//       className="form-select"
//       name="selectedMonth"
//       onChange={onChange}
//       value={selectedMonth || ""}
//     >
//       {/* placeholder option */}
//       <option value="" disabled={!!(selectedMonth || selectedMonthName)}>
//         Select Month
//       </option>

//       <option value="AllMonths">All Months</option>

//       {months().map((month, idx) => (
//         <option key={idx} value={JSON.stringify(month.createdAt)}>
//           {month.name}
//         </option>
//       ))}
//     </select>
//   </div>
// );

// export default MonthSelect;

import React, { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";

const MonthSelect = ({
  selectedMonth,
  selectedMonthName,
  months,
  onChange,
  className = "col-sm-3",
  label = "Month",
  placeholder = "Select Month",
  disabled = false,
  error,
  helperText,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const monthList = useMemo(() => {
    try {
      const res = typeof months === "function" ? months() : [];
      return Array.isArray(res) ? res : [];
    } catch {
      return [];
    }
  }, [months]);

  const handleSelect = (value, monthName) => {
    const syntheticEvent = {
      target: {
        name: "selectedMonth",
        value,
      },
    };
    onChange(syntheticEvent);
    setIsOpen(false);
  };

  const displayValue = selectedMonthName || placeholder;

  return (
    <div className={className}>
      <div style={{ position: "relative", width: "100%" }} ref={dropdownRef}>
        {label && (
          <label
            style={{
              display: "block",
              fontSize: "0.875rem",
              fontWeight: 500,
              color: error ? "#ef4444" : "#374151",
              marginBottom: "6px",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {label}
          </label>
        )}

        {/* Custom Select Button */}
        <button
          type="button"
          onClick={() => !disabled && setIsOpen((v) => !v)}
          disabled={disabled}
          style={{
            width: "100%",
            height: "38px",
            padding: "0 12px",
            border: error
              ? "1px solid #ef4444"
              : isOpen
                ? "1px solid #1F4D2C"
                : "1px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "0.9rem",
            fontFamily: "Inter, sans-serif",
            backgroundColor: disabled ? "#f9fafb" : "#ffffff",
            cursor: disabled ? "not-allowed" : "pointer",
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            transition: "all 0.2s ease",
            color: selectedMonthName ? "#374151" : "#9ca3af",
            boxShadow: isOpen
              ? error
                ? "0 0 0 3px rgba(239, 68, 68, 0.1)"
                : "0 0 0 3px rgba(31, 77, 44, 0.1)"
              : "none",
          }}
        >
          <span>{displayValue}</span>
          <i
            className="bi bi-calendar3"
            style={{
              fontSize: "1rem",
              color: disabled ? "#d1d5db" : "#6b7280",
            }}
          />
        </button>

        {/* Custom Dropdown */}
        {isOpen && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 4px)",
              left: 0,
              right: 0,
              backgroundColor: "#ffffff",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              boxShadow:
                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
              zIndex: 1000,
              maxHeight: "300px",
              overflow: "hidden",
              fontFamily: "Inter, sans-serif",
            }}
          >
            <div
              style={{
                maxHeight: "240px",
                overflowY: "auto",
                padding: "4px",
              }}
            >
              {/* Placeholder (disabled, just visual) */}
              <div
                style={{
                  padding: "10px 12px",
                  borderRadius: "6px",
                  fontSize: "0.85rem",
                  color: "#9ca3af",
                  cursor: "default",
                }}
              >
                {placeholder}
              </div>

              {/* All Months Option */}
              {/* <div
                onClick={() => handleSelect("AllMonths", "All Months")}
                style={{
                  padding: "10px 12px",
                  cursor: "pointer",
                  borderRadius: "6px",
                  fontSize: "0.9rem",
                  color: selectedMonth === "AllMonths" ? "#ffffff" : "#374151",
                  backgroundColor:
                    selectedMonth === "AllMonths" ? "#1F4D2C" : "transparent",
                  fontWeight: selectedMonth === "AllMonths" ? 600 : 400,
                  transition: "all 0.15s ease",
                }}
                onMouseEnter={(e) => {
                  if (selectedMonth !== "AllMonths") {
                    e.currentTarget.style.backgroundColor = "#f3f4f6";
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedMonth !== "AllMonths") {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }
                }}
              >
                All Months
              </div> */}

              {/* Month Options */}
              {monthList.length > 0 ? (
                monthList.map((month, idx) => {
                  const value = JSON.stringify(month.createdAt); // keep your original logic
                  const isSelected = selectedMonth === value;

                  return (
                    <div
                      key={idx}
                      onClick={() => handleSelect(value, month.name)}
                      style={{
                        padding: "10px 12px",
                        cursor: "pointer",
                        borderRadius: "6px",
                        fontSize: "0.9rem",
                        color: isSelected ? "#ffffff" : "#374151",
                        backgroundColor: isSelected ? "#1F4D2C" : "transparent",
                        fontWeight: isSelected ? 600 : 400,
                        transition: "all 0.15s ease",
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected)
                          e.currentTarget.style.backgroundColor = "#f3f4f6";
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected)
                          e.currentTarget.style.backgroundColor = "transparent";
                      }}
                    >
                      {month.name}
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    padding: "20px 12px",
                    textAlign: "center",
                    color: "#9ca3af",
                    fontSize: "0.85rem",
                  }}
                >
                  <i
                    className="bi bi-calendar-x"
                    style={{
                      fontSize: "1.5rem",
                      marginBottom: "8px",
                      display: "block",
                    }}
                  />
                  <p className="mb-0">No months found</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Helper Text */}
        {helperText && !error && (
          <small
            style={{
              display: "block",
              marginTop: "4px",
              color: "#6b7280",
              fontSize: "0.8rem",
              fontFamily: "Inter, sans-serif",
            }}
          >
            <i className="bi bi-info-circle me-1"></i>
            {helperText}
          </small>
        )}

        {/* Error Message */}
        {error && (
          <small
            style={{
              display: "block",
              marginTop: "4px",
              color: "#ef4444",
              fontSize: "0.8rem",
              fontFamily: "Inter, sans-serif",
            }}
          >
            <i className="bi bi-exclamation-circle me-1"></i>
            {error}
          </small>
        )}
      </div>
    </div>
  );
};

MonthSelect.propTypes = {
  selectedMonth: PropTypes.string,
  selectedMonthName: PropTypes.string,
  months: PropTypes.func.isRequired, // months() in your original component
  onChange: PropTypes.func.isRequired,

  className: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  helperText: PropTypes.string,
};

export default MonthSelect;
